import React, {Component} from "react";
import SimpleModal from "../../../../modules/popup/SimpleModal";
import SimpleDDL from "../../../../modules/SimpleDDL";
import FlexView from "react-flexview";
import ModalContainer from "../../../../modules/commons/ModalContainer";
import SimpleInput from "../../../../modules/SimpleInput";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import SimpleDataTable from "../../../../modules/SimpleDataTable";
import {TABLE_COLUMN_DOC_REF_CONFIG} from "../transaksiBank/config";
import Api from "../../../../Services/Api";
import {HttpStatus} from "../../../common/Constants";
import SimpleLoadingOverlay from "../../../../modules/popup/SimpleLoadingOverlay";
import ErrorAction from "../../../../Redux/ErrorRedux";
import {connect} from "react-redux";
import {fetchAsync} from "../../../../Services/Utils";
import * as R from "ramda";

class DocumentReference extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tableColumns: [...TABLE_COLUMN_DOC_REF_CONFIG.FJ(this.handleSelectDocumentReference)],
            dataTable: [],
            sourceDocument: {label: "Faktur Jual (FJ)", value: "FJ"},
            keySO: null,
            value: "",
            pagination: {
                page: 1,
                limit: 10,
                totalData: 0,
            }
        }
    }

    componentDidMount = async() => {
        this.handlerTriggerLoading();
        this.setState((prevState) => ({...prevState, loading: !prevState.loading}));
        await this.fetchDataFJ();
        this.setState((prevState) => ({...prevState, loading: !prevState.loading}));
        this.handlerTriggerLoading();
    }

    handleValueChange = (name, value) => {
        this.setState((prevState) => ({
            ...prevState,
            [name]: value
        }));
    }

    handleSourceDocumentChange = async (name, value) => {
        this.handlerTriggerLoading();
        let tableColumn;
        this.setState((prevState) => ({...prevState, loading: !prevState.loading}));
        if (value?.value === "FJ") {
            tableColumn = [...TABLE_COLUMN_DOC_REF_CONFIG.FJ(this.handleSelectDocumentReference)];
            await this.fetchDataFJ();
        } else if(value?.value === "SO"){
            tableColumn = [...TABLE_COLUMN_DOC_REF_CONFIG.SO(this.handleSelectDocumentReference)];
            await this.fetchDataSO();
        } else {
            tableColumn = [...TABLE_COLUMN_DOC_REF_CONFIG.Fjb(this.handleSelectDocumentReference)];
            await this.fetchDataFJB();
        }

        this.setState((prevState) => ({
            ...prevState,
            tableColumns: tableColumn,
            loading: !prevState.loading,
            [name]: value
        }));
        this.handlerTriggerLoading();
    }

    handleSelectDocumentReference = (index) => {
        const {dataTable, sourceDocument} = this.state;
        this.props.onClickSelectDocumentReference(dataTable[index], sourceDocument?.value);
    }

    handleSubmitSearch = async () => {
        this.handlerTriggerLoading();
        await this.fetchData();
        this.handlerTriggerLoading();
    }

    handleResetSearch = async () => {
        this.handlerTriggerLoading();
        this.setState((prevState) => ({
            ...prevState,
            keySO: null,
            value: ""
        }));

        const {sourceDocument} = this.state;
        let reqBody = sourceDocument?.value === "FJ"
            ? {kodeCabang: this.props.kodeCabang, namaPembeli: ""}
            : {kodeCabang: this.props.kodeCabang, key: "", value: ""};

        await this.fetchData(reqBody);
        this.handlerTriggerLoading();
    }

    fetchData = async (reqBody) => {
        if (this.state.sourceDocument?.value === "FJ") {
            await this.fetchDataFJ(reqBody);
        } else if(this.state.sourceDocument?.value === "SO") {
            await this.fetchDataSO(reqBody);
        } else {
            await this.fetchDataFJB(reqBody);
        }
    }

    fetchDataFJ = async (filter = {}) => {
        let req = !R.isEmpty(filter) ? filter : {
            kodeCabang: this.props.kodeCabang,
            namaPembeli: this.state.value
        }

        let res = await fetchAsync(
            Api.create("NAGAMAS_TRANSACTION").getReferenceFJ,
            this.props.setError,
            "Document Reference",
            req
        );

        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            this.setState((prevState) => ({
                ...prevState,
                dataTable: res.data.data
            }))
        }
    }

    fetchDataSO = async (filter = {}) => {
        let req = !R.isEmpty(filter) ? filter : {
            kodeCabang: this.props.kodeCabang,
            key: this.state.keySO?.value || "",
            value: this.state.value || ""
        }

        let res = await fetchAsync(
            Api.create("NAGAMAS_TRANSACTION").getReferenceSO,
            this.props.setError,
            "Document Reference",
            req
        );

        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            this.setState((prevState) => ({
                ...prevState,
                dataTable: res.data.data.map(item => {
                    return {
                        tanggalSO: item.stockOpnameDate,
                        nomorSO: item.stockOpnameNo,
                        jenisSO: item.stockOpnameType,
                        kodeLocator: item.namaLocator
                    }
                })
            }))
        }
    }

    fetchDataFJB = async (filter = {}) => {
        let req = !R.isEmpty(filter) ? filter : {
            kodeCabang: this.props.kodeCabang,
            namaPembawa: this.state.value ? "%"+this.state.value+"%" : ""
        }     

        let res = await fetchAsync(
            Api.create("NAGAMAS_TRANSACTION").getReferenceFJB,
            this.props.setError,
            "Document Reference",
            req
        );

        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            this.setState((prevState) => ({
                ...prevState,
                dataTable: res.data.data.map(item => {
                    return {
                        tanggalFjb: item.tanggalFjb,
                        nomorFjb: item.nomorFjb,
                        namaPembawa: item.namaPembawa,
                        namaPemilik: item.namaPemilik
                    }
                })
            }))
        }
    }

    handlerTriggerLoading = () => {
        this.setState((prevState) => ({
            ...prevState,
            loading: !prevState.loading
        }));
    }

    render() {
        return (
            <>
                <SimpleModal
                    title="Dokumen Referensi"
                    visible={this.props.visible}
                    onClickClose={this.props.onClickClose}
                    content={
                        <ModalContainer>
                            <div className="grid grid-2x grid-mobile-none gap-15px">
                                <div id="grid-1">
                                    <SimpleDDL
                                        id="select_options_sumber_dokumen"
                                        name="sourceDocument"
                                        label="SUMBER DOKUMEN"
                                        box="search"
                                        options={[
                                            {label: "Faktur Jual (FJ)", value: "FJ"},
                                            {label: "Stock Opname (SO)", value: "SO"},
                                            {label: "Faktur Jual Beli (FJB)", value: "Fjb"}
                                        ]}
                                        value={this.state.sourceDocument}
                                        onChange={(value, { name }) => this.handleSourceDocumentChange(name, value)}
                                    />
                                </div>
                            </div>
                            <FlexView style={{justifyContent: "space-between"}}>
                                <div className="grid grid-2x grid-mobile-none gap-15px">
                                    <div id="grid-1">
                                        {this.state.sourceDocument?.value === "SO" && (
                                            <SimpleDDL
                                                id="select_options_key_so"
                                                name="keySO"
                                                box="search"
                                                isClearable={true}
                                                containerclassname="margin-bottom-none margin-top-25px"
                                                options={[
                                                    {label: "Jenis SO", value: "type"},
                                                    {label: "Lokasi", value: "locator"}
                                                ]}
                                                value={this.state.keySO}
                                                onChange={(value, {name}) => this.handleValueChange(name, value)}
                                            />
                                        )}
                                    </div>
                                    <div id="grid-2">
                                        <FlexView vAlignContent="center" hAlignContent="right"
                                                  className="margin-bottom-20px margin-top-20px">
                                            <SimpleInput
                                                id="input_text_value_search"
                                                type="text"
                                                name="value"
                                                placeholder={
                                                    this.state.sourceDocument.value === "FJ"
                                                    ? "Nama Pembeli"
                                                    : this.state.sourceDocument.value === "SO"
                                                    ? "Jenis SO / Lokasi"
                                                    : this.state.sourceDocument.value === "Fjb"
                                                    ? "Nama Pembawa"
                                                    : ""
                                                }
                                                containerclassname="margin-bottom-none"
                                                value={this.state.value}
                                                onChange={(e) => this.handleValueChange(e.target.name, e.target.value)}
                                            />
                                            <SimpleButton
                                                text="Cari"
                                                className="margin-top-5px"
                                                onClick={this.handleSubmitSearch}
                                            />
                                            <SimpleButton
                                                text="Reset"
                                                className="margin-top-5px"
                                                onClick={this.handleResetSearch}
                                            />
                                        </FlexView>
                                    </div>
                                </div>
                            </FlexView>

                            <SimpleDataTable
                                data={this.state.dataTable}
                                columns={this.state.tableColumns}
                                rowsPerPage={this.state.pagination.limit}
                                page={this.state.pagination.page - 1}
                                toCount={this.state.pagination.totalData}
                                options={{serverSide: false}}
                            />
                        </ModalContainer>
                    }
                />
                {this.state.loading && <SimpleLoadingOverlay active={this.state.loading}/>}
            </>
        )
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        setError: (payload) => dispatch(ErrorAction.setError(payload)),
    };
};

export default connect(null, mapDispatchToProps)(DocumentReference);